//
import Model from "@/models/Model"

/**
 * @class
 */
export default class ARectify extends Model {
  
  /**
   * @description
   */
  resource () {
    return "rectify"
  }
}